import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const contestListRoute: RouteConfig = {
  path: 'contests',
  name: 'contestList',
  component: () => import(/* webpackChunkName: "ContestList" */ '@/views/mainRoute/contest/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Konkursy',
      name: 'contestList'
    },
    config: {
      title: 'Konkursy',
      name: 'contestList',
      icon: 'fa-dot-circle',
      permissions: ['CONTEST.UPDATE']
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('contest/list', {
        count: tryParseInt(to.query.count),
        start: tryParseInt(to.query.start),
        search: to.query.search
      })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.CONTEST_CANNOT_LIST }));
  }
};
